class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.header = document.querySelector('.header-wrapper');
    this.headerNav = this.header.querySelector('.header__inline-menu');
    this.isSearchModal = this.classList.contains('header__search');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    // if (!event.target.closest('.header__search')) {
    document.body.classList.add('overflow-hidden');
    // }

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );

    if (this.isSearchModal) {
      this.updateHeaderForSearchModal(true);

      document.documentElement.style.setProperty('--header-nav-height', `${Math.floor(this.headerNav.offsetHeight)}px`);
      document.documentElement.style.setProperty(
        '--header-bottom-position-for-search',
        `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
      );
    }
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');

    if (this.isSearchModal) {
      this.updateHeaderForSearchModal(false);
    }

    const modalCloseEvent = new CustomEvent('detailsModalClose', {
      bubbles: true,
      detail: { modal: this },
    });
    this.dispatchEvent(modalCloseEvent);
  }

  updateHeaderForSearchModal(isOpen) {
    const stickyHeader = document.querySelector(
      'sticky-header.homepage-header.header-transparent-hover, sticky-header.homepage-header.header-transparent'
    );
    const stickyWrapper = stickyHeader && stickyHeader.closest('.shopify-section-header-sticky');
    const defaultColorScheme = stickyHeader ? stickyHeader.dataset.defaultColorScheme : '';
    const transparentColorScheme = stickyHeader ? stickyHeader.dataset.transparentColorScheme : '';

    if (stickyHeader) {
      if (isOpen) {
        setTimeout(() => {
          stickyHeader.classList.remove('header-transparent');
          stickyHeader.classList.add('gradient', 'header-transparent-hover');
          if (defaultColorScheme) {
            stickyHeader.classList.add(defaultColorScheme);
          }

          if (transparentColorScheme) {
            stickyHeader.classList.remove(transparentColorScheme);
          }
        });
      } else {
        ``;
        setTimeout(() => {
          stickyHeader.classList.add('header-transparent');
          stickyHeader.classList.remove('gradient', 'header-transparent-hover');

          if (stickyWrapper && !stickyWrapper.classList.contains('scrolled-past-header')) {
            if (defaultColorScheme) {
              stickyHeader.classList.remove(defaultColorScheme);
            }
            if (transparentColorScheme) {
              stickyHeader.classList.add(transparentColorScheme);
            }
          }
        }, 350);
      }
    }
  }
}

customElements.define('details-modal', DetailsModal);
